/**
 * Job Documents API
 *
 * Endpoints:
 *   GET  /jobs/documents/:jobId
 *   POST /jobs/documents/:jobId/upload-url
 *   POST /jobs/documents/:jobId/complete
 */

import { apiClient } from '@/lib/api';
import type {
  JobDocument,
  JobDocumentCompleteBody,
  JobDocumentUploadUrlBody,
  JobDocumentUploadUrlResponse,
  JobDocumentsResponse,
} from '@skewb-works/contracts';

export type { JobDocumentsResponse, JobDocument };

export interface JobDocumentsParams {
  limit?: number;
  skip?: number;
}

export async function getJobDocuments(
  jobId: number,
  params: JobDocumentsParams = {},
): Promise<JobDocumentsResponse> {
  const searchParams = new URLSearchParams();
  searchParams.set('limit', String(params.limit ?? 50));
  searchParams.set('skip', String(params.skip ?? 0));

  return apiClient.get<JobDocumentsResponse>(`/jobs/documents/${jobId}?${searchParams.toString()}`);
}

export async function getJobDocumentUploadUrl(
  jobId: number,
  body: JobDocumentUploadUrlBody,
): Promise<JobDocumentUploadUrlResponse> {
  return apiClient.post<JobDocumentUploadUrlResponse>(`/jobs/documents/${jobId}/upload-url`, body);
}

export async function completeJobDocumentUpload(
  jobId: number,
  body: JobDocumentCompleteBody,
): Promise<JobDocument> {
  return apiClient.post<JobDocument>(`/jobs/documents/${jobId}/complete`, body);
}
